import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import useAuthenticated from '../Dashboard/useAuthenticated';
import Badge from '../../Components/Badge';
import { TextInput } from '../../Components/Inputs/TextInput';
import { Button } from "../../Components/Buttons";
import { boldWordInText } from '../../Utils';
import { ActionTypes } from '../../Store/Stores/User';
export default function Shopify() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appState = useAppState();
    const { user } = appState;
    const [shopDomain, setShopDomain] = useState(user?.shopify_shop_domain);

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    const updateShopDomain = async () => {
        const userUpdated = {...user, shopify_shop_domain: shopDomain};
        const response = await api.updateUser(userUpdated);
        dispatch({
            type: ActionTypes.SET_USER,
            payload: userUpdated
        });
        console.log(response);
    }

    return (
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="shopify" />
                    <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                        <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                            <h3 className='text-2xl font-bold'>{translate('setting.shopify.shopify_connection')}</h3>
                            <p className='text-md text-gray-500 max-w-4xl'>{translate('setting.shopify.description')}</p>

                            <div className='flex flex-col mt-8'>
                                <div className='flex flex-col'>
                                    <h4 className='text-lg font-bold'>{translate('setting.shopify.how_it_work')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{translate('setting.shopify.how_it_work_description')}</p>
                                    <h4 className='text-lg font-bold mt-8'>{translate('setting.shopify.set_shopify_domain')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{boldWordInText(translate('setting.shopify.set_shopify_domain_description'), ['yourstore.myshopify.com', 'votreboutique.myshopify.com'])}</p>
                                    <div className='flex flex-row bg-gray-100 p-4 rounded-md mt-4 max-w-4xl items-end justify-between gap-8'>
                                        <div className='flex flex-col w-52'>
                                            <TextInput 
                                            label={translate('setting.shopify.shopify_domain')} 
                                            placeholder={translate('setting.shopify.shopify_domain_placeholder')}
                                            value={shopDomain} 
                                            onChange={(e) => {
                                                setShopDomain(e.target.value);
                                            }} />
                                        </div>
                                        <div className='flex flex-col gap-2'>
                                        <Button onClick={updateShopDomain}>
                                            {translate('save')}
                                        </Button>
                                        </div>
                                       
                                       
                                    </div>
                                </div>
                                <div className='flex flex-col mt-8'>
                                    <h4 className='text-lg font-bold'>{translate('setting.shopify.configure_shopify_webhook')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.shopify.configure_shopify_webhook_description')}</p>
                                    <ul className="list-disc list-inside mt-2 ml-4 space-y-2">
                                        <li>{boldWordInText(translate('setting.shopify.configure_shopify_webhook_description_step_1'), ['Settings', 'Notifications', 'Webhooks', 'Paramètres'])}</li>
                                        <li>{boldWordInText(translate('setting.shopify.configure_shopify_webhook_description_step_2'), ['Create Webhook', 'Créer un webhook'])}</li>
                                        <li>{boldWordInText(translate('setting.shopify.configure_shopify_webhook_description_step_3'), ['Cart Creation', 'Création d\'un panier'])}</li>
                                        <li>{boldWordInText(translate('setting.shopify.configure_shopify_webhook_description_step_4'), ['JSON'])}</li>
                                        <li>{boldWordInText(translate('setting.shopify.configure_shopify_webhook_description_step_5'), ['https://api.hoodleapp.com/api/event/shopify/track'])}</li>
                                        <li>{boldWordInText(translate('setting.shopify.configure_shopify_webhook_description_step_6'), ['Save', 'Enregistrer'])}</li>
                                    </ul>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.shopify.configure_shopify_webhook_description_end')}</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </SidebarNav>
        </div>

    );
}